<template>
    <div class="main">
        <c-panel>
            <tabulacao-list-professor tipo="DESENHO"></tabulacao-list-professor>
        </c-panel>
    </div>
</template>

<script>
import TabulacaoListProfessor from '@/components/tabulacao/shared/tabulacao-list-professor.vue'

export default {
    components: { TabulacaoListProfessor }
}
</script>
